/* THIS FILE IS GENERATED. DO NOT EDIT */

import theme from 'sites/allas/components/standalone/SaveArticle/theme';

export const SaveArticleTheme = theme;
